export const DEADLINE_ALERT_THRESHOLD_DAYS = 6;
export const ADD_DROPDOWN_BUTTON_LIMIT = 10;

export enum OutcomeCode {
    Rejected = 'reject',
}
